import { useQuery } from '@tanstack/react-query';
import { secureHttpClient } from '../restClient';
import { useEffect } from 'react';
import { useStore } from '../store';
import { useGetStoreId } from './storeManager';

interface MerchantDetails {
  id: string;
  name: string;
  displayName: string;
  publicKey: string;
  stores: Store[];
  authClientId: string;
  appHost: string;
}

interface Store {
  storeId: string;
  name: string;
}

interface Lender {
  id: string;
  name: string;
  displayName: string;
  producatName: string;
  settings?: LenderSettings;
}

interface LenderSettings {
  apply?: Settings;
  checkout?: Settings;
}

interface Settings {
  options: {
    allowConsumerDevice: boolean;
    allowMerchantDevice: boolean;
  };
}

export interface ConfigurationNew {
  merchant: MerchantDetails;
  lenders?: Lender[];
}

export const useInitApplicationConfiguration = () => {
  const storeId = useGetStoreId();
  const updateConfiguration = useStore((state) => state.setConfiguration);
  const { data } = useQuery<ConfigurationNew>({
    queryKey: ['applicationConfigurationNew'],
    queryFn: () =>
      secureHttpClient.getConfiguration(
        {
          fetchingFunction: 'useGetConfiguration',
          fileName: 'configManagerNew.ts',
        },
        'merchant/sales-app-settings',
        storeId,
      ),
  });

  useEffect(() => {
    if (data) {
      updateConfiguration(data);
    }
  }, [data]);
};

export const useGetConfiguration = () => {
  return useStore((state) => state.configuration);
};

export const useGetLendersCheckoutSettings = () => {
  const configuration = useGetConfiguration();
  return configuration?.lenders?.map((lender) => lender.settings?.checkout);
};
